/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

export class PdfLib {
  pdfjsLib: any;
  pdfDoc: any;

  constructor() {
    // Loaded via <script> tag, create shortcut to access PDF.js exports.
    this.pdfjsLib = window["pdfjs-dist/build/pdf"];
    if (this.pdfjsLib) {
      // Specify the workerSrc property.
      this.pdfjsLib.GlobalWorkerOptions.workerSrc =
        "//mozilla.github.io/pdf.js/build/pdf.worker.js";
    }
  }

  // set PDF document, return the page width and count
  async setPdfDoc(pdfContent: any) {
    return await this.pdfjsLib
      .getDocument({ data: atob(pdfContent.licensedDoc) })
      .promise.then(async (pdfDoc_: any) => {
        this.pdfDoc = pdfDoc_;
        return await pdfDoc_.getPage(1).then(async function (page: any) {
          var viewport = await page.getViewport({ scale: 1 });
          return {
            pageWidth: viewport.width,
            pageHeight: viewport.height,
            pageCount: pdfDoc_.numPages,
          };
        });
      });
  }

  getDoc(): object {
    return this.pdfDoc;
  }
}
